<div>
  <input type="text" class="form-control" (blur)="onBlur()" [(ngModel)]="driverModel" (ngModelChange)="addDriver()"
    [ngbTypeahead]="search" [inputFormatter]="formatter" [resultFormatter]="formatter" [editable]='false' />
</div>